import React from "react";
import { Link } from "react-router-dom";

const extractSummary = (htmlContent, maxLength = 170) => {
  const tempElement = document.createElement("div");
  tempElement.innerHTML = htmlContent;
  const textContent = tempElement.textContent || tempElement.innerText || "";

  if (textContent.length > maxLength) {
    return textContent.substring(0, maxLength) + "...";
  }

  return textContent;
};

const StoriesList = ({ storiesData, currentLanguage }) => {
  return (
    <section>
      <div className="bg-gray-300">
        <div className="container mx-auto px-4 md:px-8 lg:px-12 xl:px-20 max-w-screen-xl">
          <div className="flex flex-wrap pt-5">
            {storiesData.map((stories, index) => {
              const summary = extractSummary(stories.body.value, 170);
              return (
                <div key={stories.id || index} className="md:w-1/3 mb-5 px-3">
                  <div className="right-border-around relative w-full pt-15 pr-15 pb-0 pl-0">
                    <img
                      src={stories.imageAbout.url}
                      alt={stories.imageAbout.alt}
                      className="relative w-full z-10"
                    />
                  </div>
                  <div className="bg-[#ffffff] h-auto sm:h-auto flex flex-col justify-between p-4">
                    <div>
                      <h2 className="text-[18px] text-[#263238] font-font-heading text-justify font-bold p-[20px_10px_10px] mt-[-20px] lg:line-clamp-1 md:line-clamp-1 sm:line-clamp-none md:h-11 md:mb-2 lg:h-12">
                        {stories.title}
                      </h2>
                      <p className="text-justify text-sm font-body pb-2 px-2 overflow-hidden h-16 line-clamp-2">
                        {summary}
                      </p>
                    </div>
                    <div className="text-center mt-3">
                      <Link
                        to={`/${
                          currentLanguage === "en" ? "" : "hi/"
                        }stories-of-change/${stories.path.split("/").pop()}`}
                      >
                        <button
                          type="button"
                          className="text-white font-body bg-warm-orange hover:underline focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mb-4"
                        >
                          {currentLanguage === "en"
                            ? "Read More"
                            : "अधिक पढ़ें"}
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoriesList;
